var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"top_bot_layout_wrapper"},[_c('div',{staticClass:"top_bot_layout_wrapper_top"},[_vm._t("top")],2),_c('div',{staticClass:"top_bot_layout_wrapper_bot"},[_vm._t("bot")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }